import React, { useState, useEffect, useRef } from "react";
import { ScrollContainer } from "react-indiana-drag-scroll";
import Select from "react-select";
import {
  SlOption,
  SlSelect,
  SlInput,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { useNavigate } from "react-router";
import api from "../../services/api";
import { formatDate, formatFullDate } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import Paginator from "../../shared/Paginator";
import { useDispatch, useSelector } from "react-redux";
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import { debounce } from "../../utils/Debounce";
import Datepicker from "react-tailwindcss-datepicker";
import { toast } from "react-toastify";
import {
  languageOptions,
  positionalRageOptions,
  slotOptions,
} from "../../utils/constants";
import API from "../../services/api";
import CanvasJSReact from "../dashboard/canvasjs.react";
const positionOptions = Array.from({ length: 100 }, (_, index) => {
  return { label: index, value: index };
});
const SlotOptionsArray = slotOptions.map((item, index) => {
  return { label: item, value: index };
});
const YValueformatter = (e) => {
  const suffixes = ["", "K", "L", "Cr"]; // Thousands, Lakhs, Crores
  const thresholds = [1, 1_000, 1_00_000, 1_00_00_000]; // 1, 1000, 1 Lakh, 1 Crore

  let order = thresholds.findIndex(
    (num, idx) => e.value < (thresholds[idx + 1] || Infinity)
  );

  const value = e.value / thresholds[order];

  return value.toFixed(1) + " " + suffixes[order];
};
const now = new Date();
let CanvasJS = CanvasJSReact.CanvasJS;
let CanvasJSChart = CanvasJSReact.CanvasJSChart;
function HourlyStats() {
  const [dateRange, setDateRange] = useState({
    startDate: formatFullDate(now),
    endDate: formatFullDate(now),
  });
  const [lang_ids, setLang_ids] = useState([]);
  const [positions, setPositions] = useState([]);
  const [slots, setSlots] = useState([]);
  const handleDateRange = (selectedDate) => {
    if (selectedDate.startDate && selectedDate.endDate) {
      setDateRange(selectedDate);
    } else {
      setDateRange({ startDate: null, endDate: null });
    }
  };
  const [impDataPoints, setImpDataPoints] = useState([]);
  const [clcDataPoints, setClcDataPoints] = useState([]);
  const [sptDataPoints, setSptDataPoints] = useState([]);
  const getStats = async () => {
    try {
      let result = await API({
        url: "/hourly_stats/get",
        method: "POST",
        responseType: "json",
        data: {
          lang_ids: lang_ids.length ? lang_ids : undefined,
          positions: positions.length ? positions : undefined,
          slots: slots.length ? slots : undefined,
          dateRange,
        },
      });
      if (result.code === 200) {
        if (result.data?.impPoints)
          setImpDataPoints(
            result.data.impPoints.map((item) => {
              return { ...item, x: new Date(item.x) };
            })
          );
        if (result.data?.clcPoints)
          setClcDataPoints(
            result.data.clcPoints.map((item) => {
              return { ...item, x: new Date(item.x) };
            })
          );
        if (result.data?.sptPoints)
          setSptDataPoints(
            result.data.sptPoints.map((item) => {
              return { ...item, x: new Date(item.x) };
            })
          );
      }
    } catch (error) {
      console.error("Error @ getStats", error);
    }
  };
  useEffect(() => {
    getStats();
  }, []);
  useEffect(() => {
    getStats();
  }, [lang_ids, positions, slots, dateRange]);

  const impChartRef = useRef(null);
  const clcChartRef = useRef(null);
  const sptChartRef = useRef(null);

  const [renderTime, setRenderTime] = useState(0);

  const limit = 50000;
  let y = 100;
  const dataPoints = [];

  for (let i = 0; i < limit; i++) {
    y += Math.round(Math.random() * 10 - 5);
    dataPoints.push({ x: i, y: y });
  }
  const impOptions = {
    theme: "light2",
    zoomEnabled: true,
    exportEnabled: true,
    zoomType: "x",
    panEnabled: false,
    animationEnabled: true,
    title: { text: "Impressions" },
    axisX: {
      title: "Time",
      valueFormatString: "MMM DD HH:mm",
      // viewportMinimum: impDataPoints[0]?.x,
      // viewportMaximum: impDataPoints[impDataPoints.length - 1]?.x,
      titleFontColor: "#797f84",
      labelFontColor: "#797f84",
      labelFontSize: 12,
      titleFontSize: 15,
      tickLength: 0,
      titleMargin: 20,
    },
    axisY: {
      title: "Impressions",
      titleFontColor: "#797f84",
      labelFontColor: "#797f84",
      gridColor: "#e8eaed",
      labelFontSize: 12,
      titleFontSize: 15,
      labelFormatter: YValueformatter,
    },
    toolTip: {
      contentFormatter: function (e) {
        let dataPoint = e.entries[0].dataPoint;
        let date = new Date(dataPoint.x);
        let formattedDate = date.toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return `<b>${formattedDate}</b><br>Impressions: <b>${
          dataPoint.y
        }</b><br><b>Campaigns:</b> <br>${dataPoint.campaign_names?.join(", <br>")}`;
      },
    },
    data: [
      {
        type: "line",
        dataPoints: impDataPoints,
        lineThickness: 3,
        lineColor: "#639615",
        markerColor: "#639615",
      },
    ],
  };
  const clcOptions = {
    theme: "light2",
    zoomEnabled: true,
    exportEnabled: true,
    zoomType: "x",
    panEnabled: false,
    animationEnabled: true,
    title: { text: "Clicks" },
    axisX: {
      title: "Time",
      valueFormatString: "MMM DD HH:mm",
      // viewportMinimum: clcDataPoints[0]?.x,
      // viewportMaximum: clcDataPoints[clcDataPoints.length - 1]?.x,
      titleFontColor: "#797f84",
      labelFontColor: "#797f84",
      labelFontSize: 12,
      titleFontSize: 15,
      tickLength: 0,
      titleMargin: 20,
    },
    axisY: {
      title: "Clicks",
      titleFontColor: "#797f84",
      labelFontColor: "#797f84",
      gridColor: "#e8eaed",
      labelFontSize: 12,
      titleFontSize: 15,
      labelFormatter: YValueformatter,
    },
    toolTip: {
      contentFormatter: function (e) {
        let dataPoint = e.entries[0].dataPoint;
        let date = new Date(dataPoint.x);
        let formattedDate = date.toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return `<b>${formattedDate}</b><br>Clicks: <b>${
          dataPoint.y
        }</b><br><b>Campaigns:</b> <br>${dataPoint.campaign_names?.join(", <br>")}`;
      },
    },
    data: [
      {
        type: "line",
        dataPoints: clcDataPoints,
        lineThickness: 3,
        lineColor: "#f0a95d",
        markerColor: "#f0a95d",
      },
    ],
  };
  const sptOptions = {
    theme: "light2",
    zoomEnabled: true,
    exportEnabled: true,
    zoomType: "x",
    panEnabled: false,
    animationEnabled: true,
    title: { text: "Spent" },
    axisX: {
      title: "Time",
      valueFormatString: "MMM DD HH:mm",
      // viewportMinimum: sptDataPoints[0]?.x,
      // viewportMaximum: sptDataPoints.sort((a,b) => a.y - b.y)[sptDataPoints.length - 1]?.x,
      titleFontColor: "#797f84",
      labelFontColor: "#797f84",
      labelFontSize: 12,
      titleFontSize: 15,
      tickLength: 0,
      titleMargin: 20,
    },
    axisY: {
      title: "Spent",
      titleFontColor: "#797f84",
      labelFontColor: "#797f84",
      gridColor: "#e8eaed",
      labelFontSize: 12,
      titleFontSize: 15,
      labelFormatter: YValueformatter,
    },
    toolTip: {
      contentFormatter: function (e) {
        let dataPoint = e.entries[0].dataPoint;
        let date = new Date(dataPoint.x);
        let formattedDate = date.toLocaleString("en-US", {
          month: "short",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        });
        return `<b>${formattedDate}</b><br>Spent: <b>${
          dataPoint.y
        }</b><br><b>Campaigns:</b> <br>${dataPoint.campaign_names?.join(", <br>")}`;
      },
    },
    data: [
      {
        type: "line",
        dataPoints: sptDataPoints,
      },
    ],
  };

  return (
    <div>
      <div className="flex items-center gap-3 mb-3 sticky top-0 z-10">
        <aside className="ml-auto flex items-center gap-3 flex-wrap">
          <div>
            <Select
              aria-label="Default select example"
              name="lang_ids"
              placeholder="select language"
              value={languageOptions.filter((item) =>
                lang_ids.includes(item.value)
              )}
              onChange={(selected) => {
                setLang_ids(selected.map((item) => item.value));
              }}
              options={languageOptions}
              isMulti
            />
          </div>
          <div>
            <Select
              aria-label="Default select example"
              name="lang_ids"
              placeholder="select Position"
              value={positionOptions.filter((item) =>
                positions.includes(item.value)
              )}
              onChange={(selected) => {
                setPositions(selected.map((item) => item.value));
              }}
              options={positionOptions}
              isMulti
            />
          </div>
          <div>
            <Select
              aria-label="Default select example"
              name="lang_ids"
              placeholder="select Position"
              value={SlotOptionsArray.filter((item) =>
                slots.includes(item.value)
              )}
              onChange={(selected) => {
                setSlots(selected.map((item) => item.value));
              }}
              options={SlotOptionsArray}
              isMulti
            />
          </div>

          <div className="border rounded-lg border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66">
            <Datepicker
              classNames="form-input"
              value={dateRange}
              primaryColor={"cyan"}
              showShortcuts={true}
              useRange={true} // Allow date range selection
              configs={{
                shortcuts: {
                  today: "today",
                  yesterday: "yesterday",
                  currentMonth: "currentMonth",
                  pastMonth: "lastMonth",
                },
              }}
              onChange={handleDateRange}
            />
          </div>
        </aside>
      </div>

      <div className="overflow-y-auto mb-4">
        <CanvasJSChart
          options={impOptions}
          onRef={(ref) => (impChartRef.current = ref)}
        />
        <CanvasJSChart
          options={clcOptions}
          onRef={(ref) => (clcChartRef.current = ref)}
        />
        <CanvasJSChart
          options={sptOptions}
          onRef={(ref) => (sptChartRef.current = ref)}
        />
      </div>
    </div>
  );
}

export default HourlyStats;
